<template>
  <transition 
    name="base-modal-fade" 
    appear
  >
    <div
      v-scroll-lock="bodyScrollIsLocked"
      :class="baseModalClasses"
      class="base-modal"
      @click="closeModal"
    >
      <transition 
        name="base-modal-slide" 
        appear
      >
        <base-card 
          class="base-modal__window" 
          @click.stop
        >
          <slot 
            :close-modal="closeModal" 
            name="content"
          />
        </base-card>
      </transition>
    </div>
  </transition>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  variation: {
    type: String,
    default: "page",
    validator: function (value) {
      return ["page", "fixed"].includes(value);
    },
  },
  size: {
    type: String,
    default: "medium",
    validator: function (value) {
      return ["small", "medium", "large"].includes(value);
    },
  },
  preventClose: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close-modal"]);

const bodyScrollIsLocked = ref(true);

const baseModalClasses = computed(() => ({
  [`base-modal--variation-${props.variation}`]: true,
  [`base-modal--size-${props.size}`]: true,
}));

const closeModal = () => {
  if (!props.preventClose) {
    emit("close-modal");
  }
};
</script>

<style lang="scss" scoped>
@import "./base-modal.scss";
</style>
